<template>
  <div 
    class="group flex w-fit items-center gap-[6px] rounded-[6px] bg-[--v3-root-surface-section]"
    :class="{
      'px-[8px] py-[3px]': !isSmall,
      'px-[6px] py-[4px]': isSmall,
    }"
  >
    <Icon 
      v-if="showStar"
      name="star"
      class="size-[14px] transition-all duration-150"
      :class="{
        'text-[#e2e3e5] group-hover:text-[--v3-blue-gray-bluegray-400] ': !active,

      }"
    />
    <span class="v3-body-regular-400-line-height-1.5 pointer-events-none h-[17px] !leading-[17px] text-[--v3-global-textsecondarycolor]">{{ name }}</span>
  </div>
</template>

<script lang="ts" setup>
import { withDefaults } from 'vue';

import Icon from '@/common/components/atoms/Icon';

withDefaults(
  defineProps<{
    name: string,
    isSmall?: boolean,
    active?: boolean,
    showStar?: boolean,
  }>(),
  {
    isSmall: false,
    active: false,
    showStar: false,
  });
</script>

<style scoped>
/* Add your styles here */
</style>
